import { RouteRecordRaw } from 'vue-router'

export const routes: Array<RouteRecordRaw> = [
	{
		path: '/',
		redirect: '/oc'
	},
	{
		path: '/oc',
		name: 'App',
		redirect: '/oc/prehlad',
		component: () => import('@/plugins/app/layout/default/default.layout.vue'),
		children: [
			{
				path: 'prehlad',
				name: 'Dashboard',
				component: () => import('@/plugins/app@oc/dashboard/dashboard/dashboard.vue'),
				meta: { requiresAuth: true }
			},
			{
				path: 'rezervacie',
				name: 'Reservations',
				component: () => import('@/plugins/app@oc/reservation/list/list.vue'),
				meta: { requiresAuth: true }
			},
			{
				path: 'platby',
				name: 'Payments',
				component: () => import('@/plugins/app@oc/payment/list/list.vue'),
				meta: { requiresAuth: true }
			},
			{
				path: 'objednavky',
				name: 'OC Orders',
				component: () => import('@/plugins/app@oc/order/list/list.vue'),
				meta: { requiresAuth: true }
			},
			{
				path: 'objednavky/vytvorit',
				name: 'OC Orders - Create',
				component: () => import('@/plugins/app@oc/order/create/create.vue'),
				meta: { requiresAuth: true }
			},
			{
				path: 'pacienti',
				name: 'Patients',
				component: () => import('@/plugins/app@oc/patient/list/list.vue'),
				meta: { requiresAuth: true }
			},
			{
				path: 'pacienti/:id',
				name: 'Patients - Detail',
				component: () => import('@/plugins/app@oc/patient/detail/detail.vue'),
				meta: { requiresAuth: true }
			},
			{
				path: 'kalendar',
				name: 'Calendar',
				component: () => import('@/plugins/app@oc/calendar/calendar/calendar.vue'),
				meta: { requiresAuth: true }
			}
		]
	},

	{
		path: '/prihlasenie',
		component: () => import('@/plugins/app/layout/auth/auth.layout.vue'),
		children: [
			{
				path: '',
				name: 'Login',
				component: () => import('@/plugins/app@oc/auth/login/login.vue'),
				meta: { requiresAuth: false }
			},

			{
				path: 'zabudnute-heslo',
				name: 'Forgot Password',
				component: () => import('@/plugins/app@lz/auth/forgot-password/forgot-password.vue'),
				meta: { requiresAuth: false }
			},

			{
				path: 'podmienky',
				name: 'Login - Podmienky',
				component: () => import('@/plugins/app@lz/auth/login/terms.vue'),
				meta: { requiresAuth: true }
			},

			{
				path: 'vyber-pristupu',
				name: 'Login - Select Access',
				component: () => import('@/plugins/lib@auth/views/select-access/select-access.vue'),
				meta: { requiresAuth: true }
			}
		]
	}
]
